import { ReactElement } from 'react';
import { Component as UnlockedFreeShippingIcon } from 'icons/icon-circle-lime--celebration.svg';
import styles from './Banner.module.scss';

export function UnlockedFreeShippingBanner(): ReactElement {
  return (
    <div className={`${styles.banner_container} ${styles.freeShippingBanner}`}>
      <UnlockedFreeShippingIcon />
      <div>
        You’ve unlocked free shipping!
      </div>
    </div>
  );
}
